export default function findCountryBy (countries, criteria) {
    return countries.find((country) => {
        return Object.keys(criteria).every((key) => country[key] === criteria[key])
    })
}
